import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalEventListenerService {
  clickEvents$: Subject<HTMLElement> = new Subject<HTMLElement>();
}
